



























import { Component, Mixins } from 'vue-property-decorator'
import { MenuItem } from '@/tcw/domain/types'
import BaseComponent from '@/tcw/components/BaseComponent'

@Component
export default class TcwLayouMobileFooter extends Mixins(BaseComponent) {
  private items: MenuItem[] = [
    {
      id: 1,
      icon: 'fas fa-bars',
      link: '/application/list',
      label: 'メニュー',
      badge: this.countShouninTask
    },
    {
      id: 2,
      icon: 'fas fa-stopwatch',
      link: '/kintai/list',
      label: '勤怠'
    },
    {
      id: 3,
      icon: 'fas fa-train',
      label: '交通費',
      action: () => {
        this.gotoTodaysPage('/koutsuhi/input')
      }
    },
    {
      id: 4,
      icon: 'fab fa-telegram-plane',
      link: '/teishutsu/last',
      label: '提出'
    },
    {
      id: 5,
      icon: 'fas fa-cog',
      link: '/settei/list',
      label: '設定'
    }
  ]
  private iconSize = 'fa-2x'

  private getIconClass(icon: string): string {
    return `${icon} ${this.iconSize}`
  }
  private getBadge(item: MenuItem): string | number | undefined {
    if (typeof item.badge === 'string') {
      return item.badge
    } else if (typeof item.badge === 'function') {
      return item.badge()
    } else {
      return undefined
    }
  }

  private gotoTodaysPage(link: string) {
    // ストアのcurrentDateに現在の日付を設定
    this.$tcw.$store.basic.setTargetDate(this.du.now())
    this.$router.push(link)
  }
}
